import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IFixedItem } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getFixedItemList = (params: IDynamicTableParams): Promise<IFixedItem[]> => {
  return instance()
    .post('/calculatorTariff/fixedItem/list', params)
    .then((response) => response.data);
};

export const getFixedItemAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/fixedItem/availableColumns')
    .then((response) => response.data);
};

export const getFixedItemAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/fixedItem/availableGroupColumns')
    .then((response) => response.data);
};

export const loadFixedItem = (fixedItemId: number) => {
  return instance()
    .get<IFixedItem>('/calculatorTariff/fixedItem/load/' + fixedItemId)
    .then((response) => response.data);
};

export const createFixedItem = (fixedItem: IFixedItem) => {
  return instance()
    .post<number>('/calculatorTariff/fixedItem/save', fixedItem)
    .then((response) => response.data);
};

export const updateFixedItem = (fixedItem: IFixedItem) => {
  return instance()
    .post(`/calculatorTariff/fixedItem/${fixedItem.fixedItemId}/update`, {
      fixedItemName: fixedItem.fixedItemName,
      description: fixedItem.description,
    })
    .then((response) => response.data);
};

export const deleteFixedItem = (fixedItemId: number) => {
  return instance()
    .post('/calculatorTariff/fixedItem/archive', { fixedItemId })
    .then((response) => response.data);
};

export const recoverFixedItem = (fixedItemId: number) => {
  return instance()
    .post('/calculatorTariff/fixedItem/recover', { fixedItemId })
    .then((response) => response.data);
};
